module.exports = __webpack_public_path__ + "static/media/specification_en.4ea908e3.md";